"use client";
import { IBlocks } from "@/types";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import React from "react";
import { toast } from "sonner";
import CardSetting from "@/components/admin/settings/CardSetting";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
function startsWithYoutube(str: string) {
    return (
        str.startsWith("https://youtube.com") ||
        str.startsWith("https://youtu.be") ||
        str.startsWith("https://www.youtube.com")
    );
}
export default function YoutubeVideoOptions({
    block,
    blockUpdate,
    update,
}: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [name, setName] = React.useState(block.name);
    const [url, setUrl] = React.useState(block.url);
    return (
        <div className="flex w-full flex-col gap-3">
            <div className="flex w-full flex-col gap-3">
                <CardSetting title="General" noBorder>
                    <div className="flex w-full flex-col gap-3">
                        <Input
                            label="Title"
                            variant="card"
                            className="w-full"
                            required
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                blockUpdate({
                                    ...block,
                                    name: e.target.value,
                                });
                            }}
                            onBlur={(e) => {
                                if (oldBlock.name != e.target.value) {
                                    update({
                                        ...block,
                                        name: e.target.value,
                                    });
                                    setOldBlock({
                                        ...oldBlock,
                                        name: e.target.value,
                                    });
                                }
                            }}
                        />
                        <Input
                            label="Video URL"
                            variant="card"
                            className="w-full"
                            type="text"
                            placeholder="https://www.youtube.com/watch?v=lZFUwSle7xo"
                            value={url}
                            onChange={(e) => {
                                if (!startsWithYoutube(e.target.value)) {
                                    toast.error(
                                        `The video URL needs to be a link from YouTube, such as "https://youtube.com/watch?v=..."`
                                    );
                                }
                                setUrl(e.target.value);
                                blockUpdate({
                                    ...block,
                                    url: e.target.value,
                                });
                            }}
                            onBlur={(e) => {
                                if (startsWithYoutube(e.target.value)) {
                                    if (oldBlock.url != e.target.value) {
                                        update({
                                            ...block,
                                            url: e.target.value,
                                        });
                                        setOldBlock({
                                            ...oldBlock,
                                            url: e.target.value,
                                        });
                                    }
                                }
                            }}
                        />
                        <div className="flex items-center justify-between gap-4">
                            <Label>Hide Title?</Label>
                            <Switch
                                checked={block.options.hide_title}
                                onCheckedChange={(value) => {
                                    blockUpdate({
                                        ...block,
                                        options: {
                                            ...block.options,
                                            hide_title: value,
                                        },
                                    });
                                    update({
                                        ...block,
                                        options: {
                                            ...block.options,
                                            hide_title: value,
                                        },
                                    });
                                }}
                            />
                        </div>
                    </div>
                </CardSetting>
            </div>
        </div>
    );
}
